import { Record } from 'immutable'

export interface IAssociatedGroup {
  groupId: string
  name: string
}

const AssociatedGroupRecord = Record({
  groupId: '',
  name: '',
})

export class AssociatedGroup extends AssociatedGroupRecord
  implements IAssociatedGroup {
  public static fromJS(initialState?: Partial<IAssociatedGroup>) {
    return new AssociatedGroup(initialState)
  }

  public readonly groupId: string
  public readonly name: string

  constructor(initialState?: Partial<AssociatedGroup>) {
    initialState ? super(initialState) : super()
  }
}
